import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BACKEND } from "../api";

// Pagina pubblica del cliente: mostra l'HTML pubblicato a tutto schermo, senza CRM intorno.
// Qui l'icona non è quella del CRM ma il monogramma SC con il cruscotto.
export default function CruscottoPubblico() {
  const { codice } = useParams();

  useEffect(() => {
    const precedente = document.title;
    document.title = "Cruscotto aziendale — SC Dottori Commercialisti";
    const icone = [...document.querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']")];
    const originali = icone.map((l) => l.getAttribute("href"));
    icone.forEach((l) => l.setAttribute("href", "/cruscotto-icon.png?v=1"));
    return () => {
      document.title = precedente;
      icone.forEach((l, i) => l.setAttribute("href", originali[i]));
    };
  }, []);

  return (
    <iframe
      title="Cruscotto"
      data-testid="cruscotto-pubblico"
      src={`${BACKEND}/api/cruscotti/pubblico/${codice}`}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: 0, background: "#fff" }}
    />
  );
}
